export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      functionName: "見守り機能",
      locationNumber: "location-00002",
      nickName: "アイラ２号",
      answeredAt: 1234567890123,
      answer: "良いです",
      responseStatus: 1,
      responseNote: "note test"
    }
  }
}